import * as React from "react";
import type { SVGProps } from "react";
const SvgSkiHelmet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#ski-helmet_svg__a)">
      <path d="M15.19 12c1.2 0 2.39.19 3.53.57l.59.2c.41.14.69.52.69.95v1.55a1 1 0 0 1-.69.95l-4.59 1.53c-.1.03-.21.05-.32.05-.33 0-.64-.16-.83-.44l-.53-.8a1.245 1.245 0 0 0-2.08 0l-.53.8c-.19.28-.5.44-.83.44-.11 0-.21-.02-.32-.05l-4.59-1.53a1 1 0 0 1-.68-.95v-1.56c0-.43.28-.81.68-.95l.6-.2c1.14-.38 2.33-.57 3.53-.57h6.37m0-2H8.81c-1.42 0-2.82.23-4.17.68l-.6.2a2.99 2.99 0 0 0-2.05 2.85v1.56a3 3 0 0 0 2.05 2.85l4.59 1.53a3.012 3.012 0 0 0 3.36-1.06c.56.76 1.45 1.21 2.41 1.21.32 0 .64-.05.95-.15l4.59-1.53a2.99 2.99 0 0 0 2.05-2.85v-1.55c0-1.29-.83-2.44-2.05-2.85l-.59-.2C18 10.23 16.6 10 15.18 10z" />
      <path d="M22 14h-2v-2c0-4.41-3.59-8-8-8s-8 3.59-8 8v2H2v-2C2 6.49 6.49 2 12 2s10 4.49 10 10z" />
      <path d="M8 9c-.37 0-.72-.2-.9-.55a.993.993 0 0 1 .45-1.34l2-1a.99.99 0 0 1 1.34.45c.25.49.05 1.09-.45 1.34l-2 1c-.14.07-.3.11-.45.11zM16 9c-.15 0-.3-.03-.45-.11l-2-1a1.01 1.01 0 0 1-.45-1.34c.25-.49.85-.69 1.34-.45l2 1c.49.25.69.85.45 1.34-.18.35-.53.55-.9.55zM8 22H5c-.46 0-.86-.31-.97-.76l-1-4a.995.995 0 0 1 .73-1.21.987.987 0 0 1 1.21.73L5.78 20h1.6l.72-1.45c.25-.49.85-.69 1.34-.45.49.25.69.85.45 1.34l-1 2a1 1 0 0 1-.89.55zM19 22h-3c-.38 0-.72-.21-.89-.55l-1-2a.993.993 0 0 1 .45-1.34.993.993 0 0 1 1.34.45l.72 1.45h1.6l.81-3.24c.13-.54.68-.87 1.21-.73a1 1 0 0 1 .73 1.21l-1 4c-.11.45-.51.76-.97.76z" />
    </g>
    <defs>
      <clipPath id="ski-helmet_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSkiHelmet;
